import React from "react";
import { IonIcon } from "@ionic/react";
import { closeCircleOutline } from "ionicons/icons";
import Button from "../../../../../sharable/ActionButton";
import { FromXToYPromoFloatWindow } from "./FromXToYModal.styles";
import { useFromXToYModal } from "./useFromXToYModal";

export const FromXToYModal = ({
  isOpen,
  products,
  currentProductId,
  currentProductName,
  isAccountPremium,
  onClose,
  onSave,
}) => {
  const {
    productAdvancedFields,
    updateProductAdvancedFields,
    isPromotionPriceCheaper,
    parsePrice,
    save,
  } = useFromXToYModal({
    products,
    currentProductId,
    isOpen,
    onSave,
  });

  if (!isOpen) return null;

  return (
    <FromXToYPromoFloatWindow
      className="flex direction-column"
      isAccountPremium={isAccountPremium}
    >
      <div className="icon-wrapper flex min-gap align" onClick={onClose}>
        <span>Fechar</span>
        <IonIcon icon={closeCircleOutline} className="icon" />
      </div>

      <span className="edit-product-span">
        Editando <strong>'{currentProductName}'</strong>
      </span>

      <h1>De X, Por Y</h1>
      <p>Você pode montar sua promoção como “De R$19,99, por R$18,99”.</p>

      <div className="promo-fields-list flex direction-column justify-left">
        <div className="flex direction-column">
          <h2>Valor não promocional</h2>
          <input
            onInput={(e) => {
              const parsedPrice = parsePrice(e.target.value);
              if (parsedPrice) {
                updateProductAdvancedFields("normalSellingPrice", parsedPrice);
              }
            }}
            type="text"
            placeholder="Ex: 19,99"
            value={productAdvancedFields.normalSellingPrice}
            className="normal-selling-price"
          />
        </div>

        <div className="flex direction-column">
          <h2>Valor Promocional</h2>
          <p>
            {!isPromotionPriceCheaper &&
              "Valor promocional não pode ser mais caro"}
          </p>
          <input
            className={`promotion-price ${
              !isPromotionPriceCheaper && "invalid-input"
            }`}
            onInput={(e) => {
              const parsedPrice = parsePrice(e.target.value);
              updateProductAdvancedFields("promotionPrice", parsedPrice);
            }}
            type="text"
            placeholder="Ex: 18,99"
            value={
              productAdvancedFields.promotionPrice
                ? productAdvancedFields.promotionPrice
                : products[currentProductId].promotionPrice
            }
          />
        </div>
      </div>

      {isPromotionPriceCheaper && (
        <Button
          color={"#fff"}
          text={"Salvar"}
          width={"35%"}
          $fullWidth={true}
          action={save}
        />
      )}
    </FromXToYPromoFloatWindow>
  );
};
